import { ApiServiceService } from './api-service.service';
import { Injectable } from '@angular/core';
import * as $ from 'jquery';
import * as firebase from 'firebase/app';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { ModalService } from './modal.service';


@Injectable({
  providedIn: 'root'
})

export class DataService {
  data;
  token: string;
  logged: boolean;
  userId: string
  userEmail: any;
  userType: any;
  name: any;
  localName: string;
  localEmail: string;
  persons: [];
  companies: [];
  bookmarks: any[];
  recents: any[];
  detailName: any;

  constructor(
    private afAuth: AngularFireAuth,
    private router: Router,
    private modalService: ModalService,
    private apiService: ApiServiceService) { }

  analyticsSetUserID(id) {
    const analytics = firebase.analytics();
    analytics.setUserId(id);
  }

  analyticsLogEvent(type, name) {
    const analytics = firebase.analytics();
    analytics.logEvent(type + ':' + name);
  }

  setInfoData(msg) {
    this.data = msg;

    if (localStorage.getItem('dbVersion') == undefined || localStorage.getItem('dbVersion') == null) {
      localStorage.setItem('dbVersion', this.data['db_version']);
      localStorage.setItem('dbLastUpdatedOn', this.data['db_last_updated_on']);
      this.getAll();
    } else {
      let dbVersionLocal = localStorage.getItem('dbVersion');
      if (dbVersionLocal != this.data['db_version']) {
        localStorage.setItem('dbVersion', this.data['db_version']);
        localStorage.setItem('dbLastUpdatedOn', this.data['db_last_updated_on']);
        this.getAll();
      }
    }
  }

  homePage() {
    this.detailName = 0;
    this.closeSideMenu();
    this.router.navigate(['/'], { skipLocationChange: false, replaceUrl: true })
    this.removeBottomBorder();
  }

  countryPage() { 
    this.router.navigate(['/country'], { skipLocationChange: false, replaceUrl: true });
  }

  companyPage() {
    this.router.navigate(['/company'], { skipLocationChange: false, replaceUrl: true });
  }

  personPage() {
    this.router.navigate(['/individual'], { skipLocationChange: false, replaceUrl: true });
  }

  bookmarkPage() {
    this.closeSideMenu();
    if (navigator.onLine) {
      this.router.navigate(['/bookmark'], { skipLocationChange: false, replaceUrl: true });
    } else {
      this.hideListLoader();
      this.openModal('offlineModal');
      setTimeout(() => {
        this.closeModal('offlineModal');
      }, 2000);
    }
  }

  recentPage() {
    this.closeSideMenu();
    if (navigator.onLine) {
      this.router.navigate(['/recents'], { skipLocationChange: false, replaceUrl: true });
    } else {
      this.hideListLoader();
      this.openModal('offlineModal');
      setTimeout(() => {
        this.closeModal('offlineModal');
      }, 2000);
    }
  }

  // gotoDetailPage(data) {
  //   if (navigator.onLine) {
  //     this.router.navigate(['/detail'], { state: { data: JSON.stringify(data) } });
  //   } else {
  //     this.hideListLoader();
  //     this.openModal('offlineModal');
  //     setTimeout(() => {
  //       this.closeModal('offlineModal');
  //     }, 2000);
  //   }
  // }

  gotoDetailPage(data, url) {
    
    if (navigator.onLine) {
      this.router.navigate(['/detail'], { state: { data: JSON.stringify(data),  navigateBackTo: url} });
    } else {
      this.hideListLoader();
      this.openModal('offlineModal');
      setTimeout(() => {
        this.closeModal('offlineModal');
      }, 2000);
    }
  }

  

  closeSideMenu() {
    if ($('.box').is(':visible')) {
      $('.box').hide();
    }
  }

  openModal(id: string) {
    this.modalService.open(id);
  }

  closeModal(id: string) {
    this.modalService.close(id);
  }


  openLogin() {
    $('close').show();
  }

  showLoader() {
    $('#overlay').show();
  }

  showListLoader() {
    $('#overlayList').show();
  }

  showDetailLoader() {
    $('#overlayDetail').show();
  }

  showAscLoader() {
    $('#overlayAsc').show();
  }

  showBookmarkLoader() {
    $('#overlayBookmark').show();
  }

  showRecentLoader() {
    $('#overlayRecent').show();
  }

  showCompanyLoader() {
    $('#overlayCompany').show();
  }

  showPersonLoader() {
    $('#overlayPerson').show();
  }

  showCountryLoader() {
    $('#overlayCountry').show();
  }

  showQuickLoader() {
    $('#overlayQuick').show();
  }

  showQuickAppLoader() {
    $('#overlayQuickApp').show();
  }

  hideQuickLoader() {
    $(document).ready(function () {
      $('#overlayQuick').hide();
    })
  }

  hideQuickAppLoader() {
    $(document).ready(function () {
      $('#overlayQuickApp').hide();
    })
  }

  hideLoader() {
    $(document).ready(function () {
      $('#overlay').hide();
    })
  }

  hideListLoader() {
    $(document).ready(function () {
      $('#overlayList').hide();
    })
  }

  hideDetailLoader() {
    $(document).ready(function () {
      $('#overlayDetail').hide();
    })
  }

  hideAscLoader() {
    $(document).ready(function () {
      $('#overlayAsc').hide();
    })
  }

  hideRecentLoader() {
    $(document).ready(function () {
      $('#overlayRecent').hide();
    })
  }

  hideBookmarkLoader() {
    $(document).ready(function () {
      $('#overlayBookmark').hide();
    })
  }

  hidePersonLoader() {
    $(document).ready(function () {
      $('#overlayPerson').hide();
    })
  }

  hideCompanyLoader() {
    $(document).ready(function () {
      $('#overlayCompany').hide();
    })
  }

  hideCountryLoader() {
    $(document).ready(function () {
      $('#overlayCountry').hide();
    })
  }

  getInfoData() {
    return this.data;
  }

  setDetailData(dta) {
    // console.log(dta)
    this.data = dta;
  }

  getDetailData() {
    return this.data;
  }

  setDetailName(dName) {
    // console.log(dta)
    this.detailName = dName;
  }

  getDetailName() {
    return this.detailName;
  }

  /** Logout */
  logout() {
    this.apiService.logout();
    this.afAuth.auth.signOut();
    localStorage.setItem('localName', '');
    localStorage.setItem('userId', '');
    localStorage.setItem('userEmail', '');
    localStorage.setItem('token', '');
    localStorage.setItem('userType', '');
    localStorage.setItem('picture', '');
    localStorage.setItem('loginType', '');
    localStorage.setItem('userType', '');
  }

  getAll() {
    this.getCountries();
    this.getCompanies();
    this.getPersons();
  }

  //API: get Countries
  getCountries() {

    this.apiService.getCountries().subscribe(
      data => {
        localStorage.setItem('countries', JSON.stringify(data));
      },
      error => {
        //this.resMsg('Something went wrong!')
      }
    );
  }

  //API: get Companies

  getCompanies() {
    this.apiService.getCompanies().subscribe(
      data => {
        localStorage.setItem('companies', JSON.stringify(data));
      },
      error => {
        //this.resMsg('Something went wrong!')
      }
    );
  }


  //API: get Persons
  getPersons() {
    this.apiService.getPersons().subscribe(
      data => {
        localStorage.setItem('persons', JSON.stringify(data));
      },
      error => {
        console.error('There was an error!', error);
        //this.resMsg('Something went wrong!')
      }
    );
  }


  /** Add Recent */
  addRecent(obj) {

    const userId = this.apiService.getUserID();
    this.token = this.apiService.getToken();

    if (this.token === '') {
      this.logged = false;
      //this.logout();
    } else {

      // add bookmark
      const jsonDataReg = {
        'userId': userId,
        'name': obj.name,
        'type': obj.type,
        'id':obj.id
      };

      this.apiService.postRecentData(jsonDataReg).toPromise().then(data => {
        if (data.message === 'data added') {
          console.log('Successfully added');
        } else {
          console.log('Failed to add recent');
        }
      });
    }
  }

  checkInternet() {
    if (navigator.onLine) {
      return true;
    } else {
      return false;
    }
  }

  getYear() {
    // today's date
    var date = new Date();

    // get this year
    return date.getFullYear();
  }

  /** Delete Recents */
  deleteRecents() {
    this.token = this.apiService.getToken();

    if (this.token === '') {
      this.logged = false;
      //this.logout();
    } else {
      this.apiService.deleteRecents()
      this.apiService.deleteRecents().subscribe(
        data => {
          this.recents = [];
        },
        error => {
          //this.resMsg('Something went wrong!')
        }
      );
    }
  }

  removeDetailCookies() {
    localStorage.setItem('detail', '');
  }


  removeBottomBorder() {
    $('img#advSerImg').css('border-bottom', 'none');
    $('img#companyImg').css('border-bottom', 'none');
    $('img#personImg').css('border-bottom', 'none');
    $('img#countryImg').css('border-bottom', 'none');
    $('img#homeImg').css('border-bottom', 'none');
  }

  getPersonsList() {
    this.token = localStorage.getItem('token');
    if (this.token) {
      return JSON.parse(localStorage.getItem('persons'));
    } else {
      return "Auth Fail";
    }

  }

  expandDetail() {
    $('#detail1').removeClass('col-md-6');
    $('#detail0').removeClass('col-md-6');
    $('#detail1').addClass('col-md-8');
    $('#detail0').addClass('col-md-4');
    $('#expand').hide();
    $('#rmExpand').show();
    $('.details').addClass('details1');
  }

  removeExpand() {
    $('#detail1').removeClass('col-md-8');
    $('#detail0').removeClass('col-md-4');
    $('#detail1').addClass('col-md-6');
    $('#detail0').addClass('col-md-6');
    $('.details').removeClass('details1');
    $('#expand').show();
    $('#rmExpand').hide();
  }

  getLocations() {
    const locations = [
      { name: 'Afghanistan', code: 'AF' },
      { name: 'Åland Islands', code: 'AX' },
      { name: 'Albania', code: 'AL' },
      { name: 'Algeria', code: 'DZ' },
      { name: 'American Samoa', code: 'AS' },
      { name: 'AndorrA', code: 'AD' },
      { name: 'Angola', code: 'AO' },
      { name: 'Anguilla', code: 'AI' },
      { name: 'Antarctica', code: 'AQ' },
      { name: 'Antigua and Barbuda', code: 'AG' },
      { name: 'Argentina', code: 'AR' },
      { name: 'Armenia', code: 'AM' },
      { name: 'Aruba', code: 'AW' },
      { name: 'Australia', code: 'AU' },
      { name: 'Austria', code: 'AT' },
      { name: 'Azerbaijan', code: 'AZ' },
      { name: 'Bahamas', code: 'BS' },
      { name: 'Bahrain', code: 'BH' },
      { name: 'Bangladesh', code: 'BD' },
      { name: 'Barbados', code: 'BB' },
      { name: 'Belarus', code: 'BY' },
      { name: 'Belgium', code: 'BE' },
      { name: 'Belize', code: 'BZ' },
      { name: 'Benin', code: 'BJ' },
      { name: 'Bermuda', code: 'BM' },
      { name: 'Bhutan', code: 'BT' },
      { name: 'Bolivia', code: 'BO' },
      { name: 'Bosnia and Herzegovina', code: 'BA' },
      { name: 'Botswana', code: 'BW' },
      { name: 'Bouvet Island', code: 'BV' },
      { name: 'Brazil', code: 'BR' },
      { name: 'British Indian Ocean Territory', code: 'IO' },
      { name: 'Brunei Darussalam', code: 'BN' },
      { name: 'Bulgaria', code: 'BG' },
      { name: 'Burkina Faso', code: 'BF' },
      { name: 'Burundi', code: 'BI' },
      { name: 'Cambodia', code: 'KH' },
      { name: 'Cameroon', code: 'CM' },
      { name: 'Canada', code: 'CA' },
      { name: 'Cape Verde', code: 'CV' },
      { name: 'Cayman Islands', code: 'KY' },
      { name: 'Central African Republic', code: 'CF' },
      { name: 'Chad', code: 'TD' },
      { name: 'Chile', code: 'CL' },
      { name: 'China', code: 'CN' },
      { name: 'Christmas Island', code: 'CX' },
      { name: 'Cocos (Keeling) Islands', code: 'CC' },
      { name: 'Colombia', code: 'CO' },
      { name: 'Comoros', code: 'KM' },
      { name: 'Congo', code: 'CG' },
      { name: 'Congo, The Democratic Republic of the', code: 'CD' },
      { name: 'Cook Islands', code: 'CK' },
      { name: 'Costa Rica', code: 'CR' },
      { name: 'Cote D\'Ivoire', code: 'CI' },
      { name: 'Croatia', code: 'HR' },
      { name: 'Cuba', code: 'CU' },
      { name: 'Cyprus', code: 'CY' },
      { name: 'Czech Republic', code: 'CZ' },
      { name: 'Denmark', code: 'DK' },
      { name: 'Djibouti', code: 'DJ' },
      { name: 'Dominica', code: 'DM' },
      { name: 'Dominican Republic', code: 'DO' },
      { name: 'Ecuador', code: 'EC' },
      { name: 'Egypt', code: 'EG' },
      { name: 'El Salvador', code: 'SV' },
      { name: 'Equatorial Guinea', code: 'GQ' },
      { name: 'Eritrea', code: 'ER' },
      { name: 'Estonia', code: 'EE' },
      { name: 'Ethiopia', code: 'ET' },
      { name: 'Falkland Islands (Malvinas)', code: 'FK' },
      { name: 'Faroe Islands', code: 'FO' },
      { name: 'Fiji', code: 'FJ' },
      { name: 'Finland', code: 'FI' },
      { name: 'France', code: 'FR' },
      { name: 'French Guiana', code: 'GF' },
      { name: 'French Polynesia', code: 'PF' },
      { name: 'French Southern Territories', code: 'TF' },
      { name: 'Gabon', code: 'GA' },
      { name: 'Gambia', code: 'GM' },
      { name: 'Georgia', code: 'GE' },
      { name: 'Germany', code: 'DE' },
      { name: 'Ghana', code: 'GH' },
      { name: 'Gibraltar', code: 'GI' },
      { name: 'Greece', code: 'GR' },
      { name: 'Greenland', code: 'GL' },
      { name: 'Grenada', code: 'GD' },
      { name: 'Guadeloupe', code: 'GP' },
      { name: 'Guam', code: 'GU' },
      { name: 'Guatemala', code: 'GT' },
      { name: 'Guernsey', code: 'GG' },
      { name: 'Guinea', code: 'GN' },
      { name: 'Guinea-Bissau', code: 'GW' },
      { name: 'Guyana', code: 'GY' },
      { name: 'Haiti', code: 'HT' },
      { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
      { name: 'Holy See (Vatican City State)', code: 'VA' },
      { name: 'Honduras', code: 'HN' },
      { name: 'Hong Kong', code: 'HK' },
      { name: 'Hungary', code: 'HU' },
      { name: 'Iceland', code: 'IS' },
      { name: 'India', code: 'IN' },
      { name: 'Indonesia', code: 'ID' },
      { name: 'Iran, Islamic Republic Of', code: 'IR' },
      { name: 'Iraq', code: 'IQ' },
      { name: 'Ireland', code: 'IE' },
      { name: 'Isle of Man', code: 'IM' },
      { name: 'Israel', code: 'IL' },
      { name: 'Italy', code: 'IT' },
      { name: 'Jamaica', code: 'JM' },
      { name: 'Japan', code: 'JP' },
      { name: 'Jersey', code: 'JE' },
      { name: 'Jordan', code: 'JO' },
      { name: 'Kazakhstan', code: 'KZ' },
      { name: 'Kenya', code: 'KE' },
      { name: 'Kiribati', code: 'KI' },
      { name: 'Korea, Democratic People\'S Republic of', code: 'KP' },
      { name: 'Korea, Republic of', code: 'KR' },
      { name: 'Kuwait', code: 'KW' },
      { name: 'Kyrgyzstan', code: 'KG' },
      { name: 'Lao People\'S Democratic Republic', code: 'LA' },
      { name: 'Latvia', code: 'LV' },
      { name: 'Lebanon', code: 'LB' },
      { name: 'Lesotho', code: 'LS' },
      { name: 'Liberia', code: 'LR' },
      { name: 'Libyan Arab Jamahiriya', code: 'LY' },
      { name: 'Liechtenstein', code: 'LI' },
      { name: 'Lithuania', code: 'LT' },
      { name: 'Luxembourg', code: 'LU' },
      { name: 'Macao', code: 'MO' },
      { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
      { name: 'Madagascar', code: 'MG' },
      { name: 'Malawi', code: 'MW' },
      { name: 'Malaysia', code: 'MY' },
      { name: 'Maldives', code: 'MV' },
      { name: 'Mali', code: 'ML' },
      { name: 'Malta', code: 'MT' },
      { name: 'Marshall Islands', code: 'MH' },
      { name: 'Martinique', code: 'MQ' },
      { name: 'Mauritania', code: 'MR' },
      { name: 'Mauritius', code: 'MU' },
      { name: 'Mayotte', code: 'YT' },
      { name: 'Mexico', code: 'MX' },
      { name: 'Micronesia, Federated States of', code: 'FM' },
      { name: 'Moldova, Republic of', code: 'MD' },
      { name: 'Monaco', code: 'MC' },
      { name: 'Mongolia', code: 'MN' },
      { name: 'Montserrat', code: 'MS' },
      { name: 'Morocco', code: 'MA' },
      { name: 'Mozambique', code: 'MZ' },
      { name: 'Myanmar', code: 'MM' },
      { name: 'Namibia', code: 'NA' },
      { name: 'Nauru', code: 'NR' },
      { name: 'Nepal', code: 'NP' },
      { name: 'Netherlands', code: 'NL' },
      { name: 'Netherlands Antilles', code: 'AN' },
      { name: 'New Caledonia', code: 'NC' },
      { name: 'New Zealand', code: 'NZ' },
      { name: 'Nicaragua', code: 'NI' },
      { name: 'Niger', code: 'NE' },
      { name: 'Nigeria', code: 'NG' },
      { name: 'Niue', code: 'NU' },
      { name: 'Norfolk Island', code: 'NF' },
      { name: 'Northern Mariana Islands', code: 'MP' },
      { name: 'Norway', code: 'NO' },
      { name: 'Oman', code: 'OM' },
      { name: 'Pakistan', code: 'PK' },
      { name: 'Palau', code: 'PW' },
      { name: 'Palestinian Territory, Occupied', code: 'PS' },
      { name: 'Panama', code: 'PA' },
      { name: 'Papua New Guinea', code: 'PG' },
      { name: 'Paraguay', code: 'PY' },
      { name: 'Peru', code: 'PE' },
      { name: 'Philippines', code: 'PH' },
      { name: 'Pitcairn', code: 'PN' },
      { name: 'Poland', code: 'PL' },
      { name: 'Portugal', code: 'PT' },
      { name: 'Puerto Rico', code: 'PR' },
      { name: 'Qatar', code: 'QA' },
      { name: 'Reunion', code: 'RE' },
      { name: 'Romania', code: 'RO' },
      { name: 'Russian Federation', code: 'RU' },
      { name: 'RWANDA', code: 'RW' },
      { name: 'Saint Helena', code: 'SH' },
      { name: 'Saint Kitts and Nevis', code: 'KN' },
      { name: 'Saint Lucia', code: 'LC' },
      { name: 'Saint Pierre and Miquelon', code: 'PM' },
      { name: 'Saint Vincent and the Grenadines', code: 'VC' },
      { name: 'Samoa', code: 'WS' },
      { name: 'San Marino', code: 'SM' },
      { name: 'Sao Tome and Principe', code: 'ST' },
      { name: 'Saudi Arabia', code: 'SA' },
      { name: 'Senegal', code: 'SN' },
      { name: 'Serbia and Montenegro', code: 'CS' },
      { name: 'Seychelles', code: 'SC' },
      { name: 'Sierra Leone', code: 'SL' },
      { name: 'Singapore', code: 'SG' },
      { name: 'Slovakia', code: 'SK' },
      { name: 'Slovenia', code: 'SI' },
      { name: 'Solomon Islands', code: 'SB' },
      { name: 'Somalia', code: 'SO' },
      { name: 'South Africa', code: 'ZA' },
      { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
      { name: 'Spain', code: 'ES' },
      { name: 'Sri Lanka', code: 'LK' },
      { name: 'Sudan', code: 'SD' },
      { name: 'Suriname', code: 'SR' },
      { name: 'Svalbard and Jan Mayen', code: 'SJ' },
      { name: 'Swaziland', code: 'SZ' },
      { name: 'Sweden', code: 'SE' },
      { name: 'Switzerland', code: 'CH' },
      { name: 'Syrian Arab Republic', code: 'SY' },
      { name: 'Taiwan, Province of China', code: 'TW' },
      { name: 'Tajikistan', code: 'TJ' },
      { name: 'Tanzania, United Republic of', code: 'TZ' },
      { name: 'Thailand', code: 'TH' },
      { name: 'Timor-Leste', code: 'TL' },
      { name: 'Togo', code: 'TG' },
      { name: 'Tokelau', code: 'TK' },
      { name: 'Tonga', code: 'TO' },
      { name: 'Trinidad and Tobago', code: 'TT' },
      { name: 'Tunisia', code: 'TN' },
      { name: 'Turkey', code: 'TR' },
      { name: 'Turkmenistan', code: 'TM' },
      { name: 'Turks and Caicos Islands', code: 'TC' },
      { name: 'Tuvalu', code: 'TV' },
      { name: 'Uganda', code: 'UG' },
      { name: 'Ukraine', code: 'UA' },
      { name: 'United Arab Emirates', code: 'AE' },
      { name: 'United Kingdom', code: 'GB' },
      { name: 'United States', code: 'US' },
      { name: 'United States Minor Outlying Islands', code: 'UM' },
      { name: 'Uruguay', code: 'UY' },
      { name: 'Uzbekistan', code: 'UZ' },
      { name: 'Vanuatu', code: 'VU' },
      { name: 'Venezuela', code: 'VE' },
      { name: 'Viet Nam', code: 'VN' },
      { name: 'Virgin Islands, British', code: 'VG' },
      { name: 'Virgin Islands, U.S.', code: 'VI' },
      { name: 'Wallis and Futuna', code: 'WF' },
      { name: 'Western Sahara', code: 'EH' },
      { name: 'Yemen', code: 'YE' },
      { name: 'Zambia', code: 'ZM' },
      { name: 'Zimbabwe', code: 'ZW' }
    ]
    return locations;
  }
}
